import { render, staticRenderFns } from "./EvidentiaryReviewView.vue?vue&type=template&id=2e2cc12a&"
import script from "./EvidentiaryReviewView.vue?vue&type=script&lang=js&"
export * from "./EvidentiaryReviewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports